import { forwardRef, type Ref, type SVGProps } from "react";
const IconCarSideFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M28 12h-4l-3.42-5a2 2 0 0 0-1.74-1H6.32a2 2 0 0 0-1.84 1.21l-2.26 4.36a2.1 2.1 0 0 0-.22.92V20a2 2 0 0 0 2 2h2a2 2 0 0 1 4 0h12a2 2 0 0 1 4 0h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2m-16-.5a.5.5 0 0 1-.5.5H4.81a.5.5 0 0 1-.45-.72l1.5-3A.51.51 0 0 1 6.31 8h5.19a.5.5 0 0 1 .5.5Zm8.19.5H14.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h4.19a.51.51 0 0 1 .45.28l1.5 3a.5.5 0 0 1-.45.72M24 24a2 2 0 0 1-2-2h-2a4 4 0 0 0 8 0h-2a2 2 0 0 1-2 2M8 24a2 2 0 0 1-2-2H4a4 4 0 0 0 8 0h-2a2 2 0 0 1-2 2" />
  </svg>
);
const ForwardRef = forwardRef(IconCarSideFilledSVG);
ForwardRef.displayName = "IconCarSideFilled";
export { ForwardRef as IconCarSideFilled };
